import { Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';

type RiskqTitleProps = Readonly<{
	isLastPage: boolean;
	prefix: string;
	testType: string;
}>;

export function RiskqTitle(props: RiskqTitleProps) {
	const { t } = useContext(AppContext);
	const { isLastPage, prefix, testType } = props;
	const titleKey = isLastPage ? `${testType}_derivatives_title` : `${prefix}_title`;
	return (
		<Typography className="mb-5 text-uppercase" TagName="h3">
			{t(titleKey, 'riskq')}
		</Typography>
	);
}
